import { render, staticRenderFns } from "./card_swiper.vue?vue&type=template&id=15be32a8&scoped=true&"
import script from "./card_swiper.vue?vue&type=script&lang=js&"
export * from "./card_swiper.vue?vue&type=script&lang=js&"
import style0 from "./card_swiper.vue?vue&type=style&index=0&id=15be32a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15be32a8",
  null
  
)

export default component.exports